/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Retry_HintInputs */



/**
* | output |
* | --- |
* | "We couldn't reach the domain's name servers. The record may be fine — try again in a moment." |
*
* @param {Canvas_Domain_Retry_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_retry_hint = /** @type {((inputs?: Canvas_Domain_Retry_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Retry_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Nameserver der Domain waren nicht erreichbar. Der Eintrag kann korrekt sein – versuchen Sie es in einem Moment erneut.")
	return /** @type {LocalizedString} */ ("We couldn't reach the domain's name servers. The record may be fine — try again in a moment.")
});